import React, { useEffect, useState } from "react";
import { Button, Checkbox, Modal, Popconfirm } from "antd";
import { IMAGE_BASE_URL } from "../../common/Constants";
import "./FooterBar.css";

const FooterBar = ({
  selectedLoanData,
  handleApplyLoan,
  cartItems,
  RemoveCartItem,
  showButton2,
  RemoveMultipleItems,
  CleartCart,
}) => {
  const [viewLoan, setViewLoan] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [deselectedItems, setDeselectedItems] = useState([]);

  useEffect(() => {
    if (cartItems?.length > 0) {
      setSelectedItems(cartItems?.map((it) => it?.id));
    } else {
      setViewLoan(false);
    }
  }, [cartItems]);
  const confirm = () => {
    CleartCart();
  };
  const cancel = () => {};
  return (
    <>
      <div className="footer-bar-section">
        <div className="footer-bar-block">
          <div className="footer-bar-info">
            <p>
              You have selected ({cartItems?.length}) vouchers
              {cartItems?.length > 0 && (
                <span onClick={() => setViewLoan(true)}>view selected</span>
              )}
            </p>
          </div>
          <div>
            <Popconfirm
              title="Clear Cart"
              description="Are you sure to clear the cart..?"
              onConfirm={confirm}
              onCancel={cancel}
              okText="Yes"
              cancelText="No"
              disabled={cartItems?.length < 1}
            >
              <Button
                className="footer-bar-btn clear"
                onClick={() => {
                  //clearCart();
                }}
                disabled={cartItems?.length < 1}
              >
                Clear Selected
              </Button>
            </Popconfirm>
            {showButton2 && (
              <Button
                type="primary"
                className="footer-bar-btn apply"
                onClick={handleApplyLoan}
              >
                Apply Loan for all
              </Button>
            )}
          </div>
        </div>
      </div>
      {/**viewLoan */}
      <Modal
        title="Selected Voucher"
        className="sel_loan_pop"
        width={800}
        open={viewLoan}
        closeIcon={false}
        okText="Confirm"
        cancelText="Cancel"
        onOk={() => {
          RemoveMultipleItems(deselectedItems);
        }}
        onCancel={() => {
          setViewLoan(false);
          setDeselectedItems([]);
        }}
      >
        {cartItems !== undefined &&
          cartItems.length > 0 &&
          cartItems.map((item, idx) => {
            if (item !== undefined) {
              let check = item.check;
              return (
                <label
                  key={idx}
                  className="footer-check-group"
                  htmlFor={`footerCheck${idx}`}
                >
                  <div>
                    <Checkbox
                      id={`footerCheck${idx}`}
                      checked={selectedItems?.includes(item?.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedItems(selectedItems?.concat(item?.id));
                          setDeselectedItems(
                            deselectedItems?.filter((it) => it !== item?.id)
                          );
                        } else {
                          setSelectedItems(
                            selectedItems?.filter((it) => it !== item?.id)
                          );
                          setDeselectedItems(deselectedItems?.concat(item?.id));
                        }
                      }}
                    />
                  </div>
                  <div className="footerbar-logo-block">
                    <img
                      src={`${IMAGE_BASE_URL}/${item?.agent?.icon}`}
                      alt="logo"
                      className="footerbar-logo"
                    />
                  </div>
                  <div className="card-header-group w-full">
                    <div className="card-header-block">
                      {item?.agent?.name}
                      <div className="inline-flex">
                        {item?.agent.hasPremium == 1 ? (
                          <span className="category-list">
                            <img
                              src="/images/prem_icon.svg"
                              className="w-[16px]"
                              alt="star"
                            />
                            <span className="relative top-[1px]">Premium</span>
                          </span>
                        ) : null}
                        {item?.agent.featured == 1 ? (
                          <span className="category-list">
                            <img
                              src="/images/star.svg"
                              className="w-[16px]"
                              alt="star"
                            />{" "}
                            <span className="relative top-[1px]">Featured</span>
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="card-header-info">
                      {item?.agent?.vouchers?.length < 1 ? (
                        <div className="info-header-block-list">
                          <h3 className="info-view-col">
                            Interest Rate
                            <span>
                              {item?.agent?.product?.interest_from?.slice(
                                0,
                                item?.agent?.product?.interest_from.indexOf(
                                  "."
                                ) + 2
                              )}
                              %-
                              {item?.agent?.product?.interest_to?.slice(
                                0,
                                item?.agent?.product?.interest_to.indexOf(".") +
                                  2
                              )}
                              %
                            </span>
                          </h3>
                          <h4 className="info-view-col">
                            Admin Fee
                            <span>
                              $
                              {item?.agent?.product?.admin_fee_from.slice(
                                0,
                                item?.agent?.product?.admin_fee_from.indexOf(
                                  "."
                                )
                              )}
                              -$
                              {item?.agent?.product?.admin_fee_to.slice(
                                0,
                                item?.agent?.product?.admin_fee_to.indexOf(".")
                              )}
                            </span>
                          </h4>
                        </div>
                      ) : (
                        <div className="info-header-block-list">
                          <h3 className="info-view-col">
                            Interest Rate
                            <span>
                              {item?.agent?.vouchers?.interest_rate?.slice(
                                0,
                                item?.agent?.vouchers?.interest_rate.indexOf(
                                  "."
                                ) + 2
                              )}
                              %
                            </span>
                          </h3>
                          <h4 className="info-view-col">
                            Admin Fee
                            <span>
                              $
                              {item?.agent?.product?.admin_fee_from.slice(
                                0,
                                item?.agent?.product?.admin_fee_from.indexOf(
                                  "."
                                )
                              )}{" "}
                              - $
                              {item?.agent?.product?.admin_fee_to.slice(
                                0,
                                item?.agent?.product?.admin_fee_to.indexOf(".")
                              )}
                            </span>
                          </h4>
                        </div>
                      )}
                    </div>
                  </div>
                </label>
              );
            }
          })}
      </Modal>
    </>
  );
};

export default FooterBar;
